export default import.meta.ROLLDOWN_FILE_URL_aB$Y4yyRLBAifs0yEgxESA